import { ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE, ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB, ACCESSORIES_DC_USERFORM_RESET, CREATE_ACCESSORIES_DC_FAILURE, CREATE_ACCESSORIES_DC_REQUEST, CREATE_ACCESSORIES_DC_SUCCESS, CREATE_USER_FORM_ACCESSORIES_DC, DELETE_ACCESSORIES_DC_FAILURE, DELETE_ACCESSORIES_DC_REQUEST, DELETE_ACCESSORIES_DC_SUCCESS, FETCH_ACCESSORIES_DC_FAILURE, FETCH_ACCESSORIES_DC_INVOICE_FAILURE, FETCH_ACCESSORIES_DC_INVOICE_REQUEST, FETCH_ACCESSORIES_DC_INVOICE_SUCCESS, FETCH_ACCESSORIES_DC_REQUEST, FETCH_ACCESSORIES_DC_SUCCESS, FETCH_ACCESSORIES_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS, FETCH_SINGLE_ACCESSORIES_DC_FAILURE, FETCH_SINGLE_ACCESSORIES_DC_REQUEST, FETCH_SINGLE_ACCESSORIES_DC_SUCCESS, NAVIGATE_ACCESSORIES_DC, NAVIGATE_ACCESSORIES_DC_DETAILS, RESET_ACCESSORIES_DC_INVOICE, SET_GRID_PAGE_INDEX_ACCESSORIES_DC, UPDATE_ACCESSORIES_DC_FAILURE, UPDATE_ACCESSORIES_DC_REQUEST, UPDATE_ACCESSORIES_DC_SUCCESS, HEADER_SEARCH_CALL_ONLOAD, NAVIGATE_ACCESSORIES_DC_PRINT } from "./accessoriesDC.actionsType";


export const ACCESSORIES_DC = 'accessoriesDc';

let initialState = {
    loading: false,
    gridPageIndex: 0,
    accessoriesDC: [],
    accessoriesDcInvoice: [],
    userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
    selectedAccessoriesDc: {},
    isAccessoriesDC: false,
    detailsId: [],
    activeKey: 1,
    accessoriesDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    supplierListBasedOnProgram: [],
    headerSearchCall: true,
};

export let accessoriesDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_DC_REQUEST:
        case CREATE_ACCESSORIES_DC_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_DC_REQUEST:
        case UPDATE_ACCESSORIES_DC_REQUEST:
        case DELETE_ACCESSORIES_DC_REQUEST:
        case FETCH_ACCESSORIES_DC_INVOICE_REQUEST:
            // case DELETE_BTN_UPDATE_API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDC: updatePayload
            };
        case NAVIGATE_ACCESSORIES_DC_PRINT:
            return {
                ...state,
                isAccessoriesDC: false,
                accessoriesDCSelectedValue: updatePayload.accessoriesDCSelectedValue
            }
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }

        case CREATE_ACCESSORIES_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                detailsId: updatePayload
            };

        case FETCH_ACCESSORIES_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesDcInvoice: updatePayload
            };
        case FETCH_SINGLE_ACCESSORIES_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDc: updatePayload,
                userform: updatePayload
            };
        case UPDATE_ACCESSORIES_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDc: {},
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                detailsId: []
            };
        case DELETE_ACCESSORIES_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                selectedAccessoriesDc: {},
                detailsId: []
            };
        case FETCH_ACCESSORIES_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierListBasedOnProgram: updatePayload
            }
        case FETCH_ACCESSORIES_DC_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_DC_FAILURE:
        case CREATE_ACCESSORIES_DC_FAILURE:
        case UPDATE_ACCESSORIES_DC_FAILURE:
        case DELETE_ACCESSORIES_DC_FAILURE:
        case FETCH_ACCESSORIES_DC_INVOICE_FAILURE:
            // case DELETE_BTN_UPDATE_API_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case SET_GRID_PAGE_INDEX_ACCESSORIES_DC:
            return {
                ...state,
                gridPageIndex: payload
            };
        case ACCESSORIES_DC_USERFORM_RESET:
            return {
                ...state,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
                selectedAccessoriesDc: {},
                detailsId: [],
                activeKey: 1
            };
        case RESET_ACCESSORIES_DC_INVOICE:
            return {
                ...state,
                accessoriesPoInvoice: []
            };
        case NAVIGATE_ACCESSORIES_DC_DETAILS:
            return {
                ...state,
                isAccessoriesDC: true,
                loading: false,
                accessoriesDCSelectedValue: updatePayload.accessoriesDCSelectedValue
            };
        case NAVIGATE_ACCESSORIES_DC:
            return {
                ...state,
                isAccessoriesDC: false
            };
        case ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: ''
                },
                activeKey: 2
            };
        case ACCESSORIES_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: ''
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
